import _ from 'lodash';
import { gql } from '@apollo/client';

import { useEdeQuery, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

export const useReferenceData = (state: string, year: number) => {
  const getStateReferenceQueryName = useEdeQueryName('GET_STATE_REFERENCE');
  const getSystemReferenceQueryName = useEdeQueryName('GET_SYSTEM_REFERENCE');

  const GET_REFERENCE = gql`
    query SystemStateReference($stateCode: CoverageStateEnum!, $years: [String!]!) {
      ${getStateReferenceQueryName} (stateCode: $stateCode) {
        fosterCareAgeThreshold
        inStateFosterCareRequired
        acceptMedicaidEligibilityIndicator
        deprivationRequirementRetained
        optionRequireWorkQuarters
        under21AndFtsOption
        optionStudentResidency
        chipForStateHealthBenefits
        stateChipWaitingPeriod
        percentFplAdultGroup
        optionCaretakerRelationship
        stateOptionForCountingCashSupport
        stateOptionForPredictableIncome
        effectiveDateOfCoverage
        stateRunsMedicaidGapFiling
        acceptChipEligibilityIndicator
        optionForDependentStudent
        medicaidProgramName
        chipProgramName
        medicaidAgencyName
        chipAgencyName
        medicaidWebsite
        chipWebsite
        medicaidPhone
        medicaidTty
        chipPhone
        chipTty
        medicaidAddress
        chipAddress
      }
      ${getSystemReferenceQueryName} (years: $years) {
        year
        barOptOutEndDate
        barOptOutStartDate
        barVisibilityDate
        updateCutoffDate
        hideBarApplicationsEndDate
        oeEndDate
        oeStartDate
        janFirstCutoffDate
        ffmStates
        marriageQuestionAgeCutoff
        medicaidChildAgeStudentThreshold
        medicaidChildAgeThreshold
        medicaidDenialDayQuantity
        medicareAgeLimitMax
        medicareAgeLimitMin
        pregnancyAgeCutOff
      }
    }
  `;

  const { data } = useEdeQuery(GET_REFERENCE, {
    skip: !state || !year,
    variables: {
      stateCode: state,
      years: [String(year)],
    },
  });

  const stateReference = _.get(data, 'stateReference');
  const systemReference = _.get(data, 'systemReference[0]');

  return {
    stateReference,
    systemReference,
  };
};
